// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1VyTz","productName":"Table_productName__2yZhL"};